import type { IPaginationSettings } from '@/api/types';
import type { EParticipantsStatus } from '@/shared/consts';

/**
 * Статусы импорта участников корпоративной школы
 */
export enum EParticipantsImportStatus {
  Completed = 'completed',
  Processing = 'processing',
  Pending = 'pending',
  PartiallyCompleted = 'partially_completed',
}

export interface IParticipant {
  id: number;
  status: EParticipantsStatus;
  name: string;
  email: string;
  phone: string;
  enrolling_date: string;
  expulsion_reason: string;
  accepted_at: string;
  expelled_at: string;
}

export interface IParticipantsStat {
  accepted: number;
  pending_authorization: number;
  total: number;
}

export interface IParticipantsResponse {
  data: IParticipant[];
  meta: {
    pagination: IPaginationSettings;
    stats: IParticipantsStat;
  };
}

export interface IImportError {
  row: number;
  message: string;
}

export interface IImportValidationError {
  code: string;
  message: string;
  context?: {
    row?: number;
  };
}

export interface IParticipantsImport {
  id: number;
  file: {
    filename: string;
  };
  status: EParticipantsImportStatus;
  total_rows: number;
  processed_count: number;
  error_count: number;
  created_at: string;
  report: {
    errors: IImportError[];
  };
  school_id: number;
}

export interface IParticipantsImportStat {
  total: number;
  succeed: number;
  with_errors: number;
  total_memberships: number;
}

export interface IParticipantsImportsResponse {
  data: IParticipantsImport[];
  meta: {
    stats: IParticipantsImportStat;
  };
}

export interface IParticipantsImportResponse {
  data: IParticipantsImport;
}

export interface ICreateParticipantsImportResponse {
  data: IParticipantsImport;
}

export interface INewParticipantsImportResponse {
  data: Omit<IParticipantsImport, 'id' | 'status' | 'file'>;
}
